export default ((pluginState, action) => {
  return pluginState;
});